import { TRANSFORM_SSR_STATE, TransformSSRState } from 'app/redux/ssrState';

import {
  CLEANUP_HISTORY_STAKES, CleanupHistoryStakes,
  fetchHistoryStakes,
} from '../actions/historyStakes';
import { EntriesState } from '../types/entries';
import { createStakeListReducer, initialState } from '../utils/entries-reducer';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SSRHistoryStakes = any;

type HistoryStakesActions =
  | TransformSSRState<SSRHistoryStakes>
  | CleanupHistoryStakes;

const historyStakes = createStakeListReducer({
  REQUEST: fetchHistoryStakes.pending.type,
  SUCCESS: fetchHistoryStakes.fulfilled.type,
  FAILURE: fetchHistoryStakes.rejected.type,
  CLEANUP: CLEANUP_HISTORY_STAKES,
});

export default function (state = initialState, action: HistoryStakesActions): EntriesState {
  if (
    action.type === TRANSFORM_SSR_STATE
    || action.type === fetchHistoryStakes.pending.type
    || action.type === fetchHistoryStakes.fulfilled.type
    || action.type === fetchHistoryStakes.rejected.type
    || action.type === CLEANUP_HISTORY_STAKES
  ) {
    return historyStakes(state, action);
  }

  return state;
}
